import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import { loadFonts } from './plugins/webfontloader'
import router from './plugins/router'
import store from './store/store'
loadFonts()

// Import MDI icons (needed for checkboxes and other controls)
import '@mdi/font/css/materialdesignicons.css'
createApp(App)
  .use(vuetify)
    .use(router).use(store)
  .mount('#app')
